export default __webpack_public_path__ + "static/media/plant-2798849_1920.86477928.jpg";